module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1b_Image8n.be52039d.jpg";